import React, { useEffect, useState } from 'react';
import Aside from './components/Aside';
import Header from './components/Header';
import {
  BrowserRouter as Router,
  useMatch,
  useResolvedPath,
} from 'react-router-dom';
import Home from './page/Home';
import { Routes, Route } from 'react-router-dom';
import Courses from './page/Courses';
import Publications from './page/Publications';
import Talks from './page/Talks';
import SingleCourse from './page/SingleCourse';
import Contact from './page/Contact';
import Footer from './components/Footer';
import { useScript } from './utils';

export default function App() {
  const [showAside, setShowAside] = useState(true);
  useScript('assets/vendors/jquery/dist/jquery.min.js');
  useScript('assets/vendors/@popperjs/core/dist/umd/popper-base.min.js');
  useScript('assets/vendors/bootstrap/dist/js/bootstrap.min.js');
  useScript('assets/js/live-resume.js');
  useScript('https://cdn.datatables.net/1.11.4/js/jquery.dataTables.min.js');
  useScript(
    'https://cdn.datatables.net/1.11.4/js/dataTables.bootstrap4.min.js'
  );
  const windowWidth = window.innerWidth;
  let resolved = useResolvedPath('/');
  let match = useMatch({ path: resolved.pathname, end: true });
  useEffect(() => {
    if (windowWidth >= 992 || match) {
      // setNavClass('collapsible-nav show');
      setShowAside(true);
    } else {
      // setNavClass('collapsible-nav');
      setShowAside(false);
    }
  }, [windowWidth, match]);

  return (
    <>
      {/* <div className="d-flex flex-column min-vh-100"> */}
      <Header />
      <div class='content-wrapper '>
        <Aside show={showAside} />
        <main>
          <Routes>
            <Route exact path='/' element={<Home />} />
            <Route exact path='/courses' element={<Courses />} />
            <Route exact path='/courses/:id' element={<SingleCourse />} />
            <Route exact path='/publications' element={<Publications />} />
            <Route exact path='/talks' element={<Talks />} />
            <Route exact path='/contact' element={<Contact />} />
          </Routes>
        </main>
      </div>
      {/* <Footer /> */}
      {/* </div> */}
    </>
  );
}
